<script>

	import './style.scss'

	import {
		URL_PREFIX
	} from '@/constants'

	export default {
		name: 'companies',
		data: () => ({
			URL_PREFIX,
		})
	}

</script>

<template>
	<div class='companies'>
		<header>
			<h1>
				Choose a company to get questions
			</h1>
		</header>
		<div class='container'>
			<a class='company facebook' :href='`${URL_PREFIX}/company/facebook`'>
				<img class='logo' src='/static/companies/facebook.svg'>
			</a>
			<a class='company google' :href='`${URL_PREFIX}/company/google`'>
				<img class='logo' src='/static/companies/google.svg'>
			</a>
			<a class='company microsoft' :href='`${URL_PREFIX}/company/microsoft`'>
				<img class='logo' src='/static/companies/microsoft.svg'>
			</a>
			<a class='company amazon' :href='`${URL_PREFIX}/company/amazon`'>
				<img class='logo' src='/static/companies/amazon.svg'>
			</a>
			<a class='company apple' :href='`${URL_PREFIX}/company/apple`'>
				<img class='logo' src='/static/companies/apple.svg'>
			</a>
			<a class='company snapchat' :href='`${URL_PREFIX}/company/snap`'>
				<img class='logo' src='/static/companies/snapchat.svg'>
			</a>
			<a class='company yelp' :href='`${URL_PREFIX}/company/yelp`'>
				<img class='logo' src='/static/companies/yelp.svg'>
			</a>
			<a class='company linkedin' :href='`${URL_PREFIX}/company/linkedin`'>
				<img class='logo' src='/static/companies/linkedin.svg'>
			</a>
			<a class='company twitter' :href='`${URL_PREFIX}/company/twitter`'>
				<img class='logo' src='/static/companies/twitter.svg'>
			</a>
			<a class='company bloomberg' :href='`${URL_PREFIX}/company/bloomberg`'>
				<img class='logo' src='/static/companies/bloomberg.svg'>
			</a>
			<a class='company uber' :href='`${URL_PREFIX}/company/uber`'>
				<img class='logo' src='/static/companies/uber.svg'>
			</a>
			<a class='company goldman' :href='`${URL_PREFIX}/company/goldman`'>
				<img class='logo' src='/static/companies/goldman.svg'>
			</a>
		</div>
	</div>
</template>



// WEBPACK FOOTER //
// src/components/Companies/Companies.vue